
// function toggleGiftList(event) {
//   event.preventDefault();
//   const popup = event.currentTarget.closest('.ajax-cart__form-wrapper').querySelector('.js-freeGiftPopup');
//   if (popup.style.display === 'none' || popup.style.display === '') {
//     console.log('toggleGiftList')
//     popup.style.display = 'flex';
//   } else {
//     popup.style.display = 'none';
//   }
// }
/// close gift popup
function toggleGiftList(event) {
  event.preventDefault();
  const popup = event.currentTarget.closest('.ajax-cart__form-wrapper').querySelector('.js-freeGiftPopup');
  const cartCount = document.querySelector('.cart_drawer_header_wrp .cart_count'); 

  if (popup.style.display === 'none' || popup.style.display === '') {
    console.log('toggleGiftList');
    popup.style.display = 'flex';
    cartCount.classList.add('is-active'); 
  } else {
    popup.style.display = 'none';
    cartCount.classList.remove('is-active'); 
  }
}

// close menu icon
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".menu_back_ic").forEach(icon => {
    icon.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      let accordionPanel = this.closest(".c-accordion__panel");

      if (accordionPanel) {
        accordionPanel.classList.remove("is-active");
      }

      document
        .querySelectorAll(".menu_main_li .dropdown-arrow.dropdown-btn")
        .forEach(arrow => {
          arrow.setAttribute("aria-expanded", "false");
        });
    });
  });
});





function slideCollectionListDesktop(ele){
  // console.log(`window width is ${window.innerWidth}px`);
    var flkty = new Flickity(ele, {
    cellAlign: 'center',
    pageDots: false,
    contain: true,
    prevNextButtons: true,
    groupCells: 1,
    wrapAround: false
  });
}
function slideCollectionListMobile(ele){
  // console.log(`window width is ${window.innerWidth}px`);
    var flkty = new Flickity(ele, {
    wrapAround: false,
    cellAlign:  "center",
    dragThreshold: "0",
    contain:  true,
    freeScroll:  false,
    prevNextButtons:  true,
    pageDots:  false,
    groupCells: 1,
    watchCSS:  true,
  });
}

function slideCollectionListFlickitySlider(){    
  if(window.innerWidth > 768){
    const js_flickity_slider_desktop = document.querySelectorAll('.js-flickity-section-desktop');
    if(js_flickity_slider_desktop.length > 0){
      js_flickity_slider_desktop.forEach(ele=>{
        slideCollectionListDesktop(ele);
      })
    }
  } else{
    const js_flickity_slider_mobile = document.querySelectorAll('.flickity-section');
    if(js_flickity_slider_mobile.length > 0){
      js_flickity_slider_mobile.forEach(ele=>{
        slideCollectionListMobile(ele);
      })
    }
  }
}

document.addEventListener('DOMContentLoaded', slideCollectionListFlickitySlider);
window.addEventListener('resize', slideCollectionListFlickitySlider);

  window.onclick = function(event) {
    const popup = document.getElementById('freeGiftPopup');
    if (event.target === popup) {
      popup.style.display = 'none';
    }
  };


  const atcButtons = document.querySelectorAll(".ajax-cart__form-wrapper.cart-wrapper .js-ajax-submit");
  atcButtons.forEach(cartBtn => {
    cartBtn.addEventListener("click", function(event) {
      event.preventDefault(); 
     const variant_id = this.event.target.dataset('variant-id');
      
      let form = this.closest("form");
      let formData = new FormData(form);

      fetch("/cart/add.js", {
        method: "POST",
        body: JSON.stringify({
          id: variant_id,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
          console.log("Gift added:", data);
          let successMsg = form.querySelector(".js-added-msg");
          if (successMsg) {
            successMsg.style.display = "block";
          }
          updateCartCount();
      })
      .catch(error => {
          console.error("Error:", error);
          let errorMsg = form.querySelector(".js-error-msg");
          if (errorMsg) {
              errorMsg.style.display = "block";
          }
      });
  });
    function updateCartCount() {
      fetch("/cart.js")
      .then(response => response.json())
      .then(cart => {
          let cartCountElement = document.querySelector(".cart-count");
          if (cartCountElement) {
              cartCountElement.textContent = cart.item_count;
          }
      });
    }
})   



// ==========menu_back_button====



// document.addEventListener("DOMContentLoaded", function () {
//     document.querySelectorAll(".menu_back_ic").forEach(function (backButton) {
//         backButton.addEventListener("click", function () {
//             let activeMenu = this.closest(".first_level_menu");

//             if (activeMenu) {
//                 activeMenu.classList.remove("is-active"); // Remove active class
//                 activeMenu.style.display = "none"; // Hide the menu
//             }
//         });
//     });
// });


document.addEventListener("DOMContentLoaded", function () {
  const dropdownItems = document.querySelectorAll('.navigation__menuitem--dropdown');

  dropdownItems.forEach(item => {
    item.addEventListener('mouseenter', () => {
      document.body.classList.add('menu_hover_active_body');
    });

    item.addEventListener('mouseleave', () => {
      document.body.classList.remove('menu_hover_active_body');
    });
  });
});


// window.toggleAccordion = function () {
//   console.log('In')
//     document.querySelectorAll(".cart_drawer_header_shipping .ajax-cart__summary-wrapper .js-accordion-header-drawer").forEach(function (ele) {
//         ele.addEventListener("click", function (event) { 
//           ele.classList.toggle('active');
//             let panel = event.currentTarget.nextElementSibling;
//             panel.style.display = (panel.style.display === "block" || panel.style.display === "") ? "none" : "block";
//         });
//     });
// };

/////
 window.toggleAccordion = function () {
    console.log('In');
    const headers = document.querySelectorAll(".cart_drawer_header_shipping .ajax-cart__summary-wrapper .js-accordion-header-drawer");

    headers.forEach(function (ele) {
      ele.addEventListener("click", function (event) {
        ele.classList.toggle('active');
        let panel = event.currentTarget.nextElementSibling;
        panel.style.display = (panel.style.display === "block" || panel.style.display === "") ? "none" : "block";
      });
    });

    // Automatically open the first accordion
    if (headers.length > 0) {
      const firstHeader = headers[0];
      const firstPanel = firstHeader.nextElementSibling;

      // Open it
      firstHeader.classList.add('active');
      firstPanel.style.display = 'block';

      // Close after 10 seconds
      setTimeout(() => {
        firstHeader.classList.remove('active');
        firstPanel.style.display = 'none';
      }, 10000);
    }
  };

  // Ensure it runs on page load
  document.addEventListener("DOMContentLoaded", window.toggleAccordion);

window.toggleAccordionCart = function () {
  document.querySelectorAll(".cart-page .ajax-cart__info-wrapper .js-accordion-header-drawer").forEach(function (cartEle) {
    if (!cartEle.classList.contains('listener-added')) {
      cartEle.classList.add('listener-added');
      cartEle.addEventListener("click", function (event) {
        cartEle.classList.toggle('active');
        let panelCart = event.currentTarget.nextElementSibling;
        panelCart.style.display = panelCart.style.display === "block" || panelCart.style.display === "" ? "none" : "block";
      });
    }
  });
};

window.toggleAccordionCart();

// window.toggleAccordion();

window.attachOpenGiftWrapper = function () {
  setTimeout(function() {
    const cartFreeGiftWrapper = document.querySelector('.template-cart .cart-page .shipping-progress.cart-shipping-bar .view-free-gift.cart-gift');
    const mainparent = document.querySelector('.template-cart .cart-page .cart-shipping-bar .shipping_progress_wrp');
    const nextSibling = document.querySelector('.template-cart .cart-page .cart-shipping-bar #freeGiftPopup'); 
    if (cartFreeGiftWrapper) {
      cartFreeGiftWrapper.addEventListener('click', function (evt) {
        mainparent.classList.add('hidden');
        nextSibling.classList.add('popup-visible');
        nextSibling.style.display = 'block';
      });
    }
     const closeIcon = document.querySelector('.template-cart .cart-page .shipping-progress.cart-shipping-bar .close-popup');
     if (closeIcon) {
       closeIcon.addEventListener('click', function () {
         mainparent.classList.remove('hidden');
         nextSibling.classList.remove('popup-visible');
         nextSibling.style.display = 'none';
       }) 
     }
   }); 
}

// window.attachOpenGiftWrapper();

////hide search menu

document.addEventListener("DOMContentLoaded", function () {
    const searchBoxes = document.querySelectorAll(".searchbox__input");
    searchBoxes.forEach((searchBox) => {
      const searchMenu = searchBox.closest(".sidebar__search-container")?.querySelector("ul");
      if (searchMenu) {
        searchBox.addEventListener("input", function () {
          if (this.value.trim() !== "") {
            searchMenu.classList.add("hidden");
          } else {
            searchMenu.classList.remove("hidden");
          }
        });
      }
    });
});

window.StopFormSubmit = function () {
  setTimeout(function () {
    const inputFields = document.querySelectorAll('.ajax-cart__item-quantity input[type="number"]');
    inputFields.forEach(inputField => {
      inputField.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          return false;
        }
      });
    });
  }, 500);  
}
window.StopFormSubmit();

document.addEventListener('DOMContentLoaded', () => {
  const isMobile = window.matchMedia('(max-width: 740px)').matches;

  document.querySelectorAll('.has-readmore').forEach(wrapper => {
    if (
      wrapper.classList.contains('readmore-mobile') && !isMobile ||
      wrapper.classList.contains('readmore-desktop') && isMobile
    ) {
      return;
    }

    const limit = +wrapper.dataset.wordLimit;
    const button = wrapper.querySelector('.readmore-toggle');
    const paragraphs = [...wrapper.querySelectorAll('p')];

    if (!button || !paragraphs.length) return;

    let wordCount = 0;
    let truncated = false;

    paragraphs.forEach(p => {
      if (!p.dataset.fullHtml) {
        p.dataset.fullHtml = p.innerHTML;
      }

      const words = p.textContent.trim().split(/\s+/);

      if (wordCount >= limit) {
        p.classList.add('is-hidden');
        truncated = true;
        return;
      }

      if (wordCount + words.length > limit) {
        const allowed = limit - wordCount;
        p.dataset.shortText = words.slice(0, allowed).join(' ') + '…';
        p.innerHTML = p.dataset.shortText;
        truncated = true;
      }

      wordCount += words.length;
    });

    if (!truncated) {
      button.remove();
      return;
    }

    wrapper.classList.add('is-collapsed');

    button.addEventListener('click', () => {
      const collapsed = wrapper.classList.toggle('is-collapsed');

      paragraphs.forEach(p => {
        if (collapsed && p.dataset.shortText) {
          p.innerHTML = p.dataset.shortText;
        } else if (!collapsed && p.dataset.fullHtml) {
          p.innerHTML = p.dataset.fullHtml;
        }
      });

      button.textContent = collapsed ? 'Read more' : 'Read less';
    });
  });
});